<div class="sidebar-wrapper d-flex flex-column h-100">
    <div class="client-sidebar text-primary-green border h-100 rounded-lg d-flex flex-column shadow p-2 bg-light"
      :class="{ 'admin-management-sidebar': should_show_template }">
        <button
          class="btn btn-close d-lg-none align-self-end m-2 d-none"
          @click="$emit('close')"
          aria-label="Close sidebar"></button>
        <div class="sidebar-brand text-center mt-3">
          <div v-if="should_show_template" class="admin-sidebar-brand">
            <a class="mt-3" id="sidebar-toggle" href="/company_management" @click.prevent="go_to_programmes">
              <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
            </a>
          </div>
          <hr class="d-none text-white mx-2 mt-2"/>
        </div>
        
        <div class="sidebar-content flex-grow-1 scrollable-container">
          <div class="d-flex justify-content-center  h-100">
            <!-- Workflows Dynamic Sidebar -->
            <div class="sidebar-sections h-100">
              <!-- User Management Sidebar (Hardcoded) -->
              <template v-if="should_show_template">
                <nav class="entity-sidebar admin-sidebar-nav d-flex flex-column h-100">
                  <ul class="nav flex-column flex-grow-1">
                    <li class="dwypd-sidebar-group-label">Management</li>
                    <li>
                      <router-link to="/company_management" @click="set_hardcoded_active('company_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('company_management') || is_route_active(['/company_management']) }">
                        <i class="bi bi-folder-fill fs-5"></i>
                        <span class="sidebar-text">Programmes</span>
                      </router-link>
                    </li>
                    
                    <li v-if="is_super_user">
                      <router-link to="/user_management" @click="set_hardcoded_active('user_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('user_management') || is_route_active(['/user_management']) }">
                        <i class="fas fa-users fs-5"></i>
                        <span class="sidebar-text">Users</span>
                      </router-link>
                    </li>
                    <li v-if="is_super_user">
                      <router-link to="/action_management" @click="set_hardcoded_active('action_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('action_management') || is_route_active(['/action_management']) }">
                        <i class="fa-solid fa-screwdriver-wrench fs-5"></i>
                        <span class="sidebar-text">Actions</span>
                      </router-link>
                    </li>
                    
                    <!-- System Configuration -->
                    <li v-if="is_super_user" class="system-config-item">
                      <div class="dwypd-sidebar-group-label company-sidebar-group-label">Configuration</div>
                      <a
                        class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center system-config-toggle"
                        href="#"
                        role="button"
                        :aria-expanded="system_config_open ? 'true' : 'false'"
                        @click.prevent="toggle_system_config"
                      >
                        <span class="d-flex align-items-center gap-2"><i class='fa-solid fa-gear fs-5'></i><span class="sidebar-text">System Configuration</span></span>
                        <i class="bx bxs-chevrons-down rotate-icon" :class="{ 'rotate-180': system_config_open }"></i>
                      </a>
                      <ul v-show="system_config_open" class="list-unstyled ps-3 mt-2 system-config-list">
                        <li>
                          <router-link to="/form_management" @click="set_hardcoded_active('form_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('form_management') }">
                            <i class='bx bxs-chevrons-right'></i>
                            <span class="sidebar-text">Manage Forms</span>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/manage_questions" @click="set_hardcoded_active('manage_questions')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('manage_questions') }">
                            <i class='bx bxs-chevrons-right'></i>
                            <span class="sidebar-text">Manage Questions</span>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/view_template" @click="set_hardcoded_active('view_template')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('view_template') }">
                            <i class='bx bxs-chevrons-right'></i>
                            <span class="sidebar-text">Manage Templates</span>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/signing_workflow" @click="set_hardcoded_active('signing_workflow')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('signing_workflow') }">
                            <i class='bx bxs-chevrons-right'></i>
                            <span class="sidebar-text">Manage Signing</span>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/status_management" @click="set_hardcoded_active('status_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('status_management') }">
                            <i class='bx bxs-chevrons-right'></i>
                            <span class="sidebar-text">Manage Statuses</span>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div class="sidebar-footer admin-sidebar-footer p-3 mt-auto">
                    <div class="d-flex align-items-center mb-3 gap-2">
                      <div class="avatar-circle flex-shrink-0 text-capitalize">
                        {{ (currently_logged_in || '').slice(0, 1) }}
                      </div>
                      <div class="user-info">
                        <p class="m-0 fw-bold text-xxs">{{ currently_logged_in }}</p>
                        <small class="text-xxs">{{ role }}</small>
                      </div>
                    </div>
                    <button type="button" class="admin-sidebar-logout nav-link nav-item p-0 text-xxs" @click="logout">
                      <i class="bi bi-box-arrow-right fs-5 me-2"></i>
                      <span>Sign Out</span>
                    </button>
                  </div>
                </nav>
              </template>
              <!-- Entity Sidebar -->
              <div v-else-if="['/view_user_trust_form', '/view_all_user_forms','/apply_for_job','/entity_overview', '/requested_information_update', '/unresolved_request', '/resolved_requests', '/enquiry_chat', '/entity_application_overview', '/application_overview_details', '/auto_verification_overview', '/entity_overview', '/view_contracts', '/entity_risk_assessment', '/answer_risk_assessment', '/lead_questionnaire', '/lead_questionnaire_form', '/entity_enquiry_management', '/proof_of_payments'].includes($route.path)">
                <a class="mt-3" id="sidebar-toggle">
                  <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
                </a>
                <hr class="text-white mx-2 mt-2"/>
                <nav v-if="sorted_menu_items?.length" class="entity-sidebar">
                  <ul class="nav flex-column">
                    <template v-for="component in sorted_menu_items" :key="component.id">
                      <li
                        v-for="sub in component.sub_components"
                        :key="sub.id"
                        :class="{ 'd-none': is_hidden_sidebar_item(sub) }"
                      >
                        <!-- If no child components -->
                        <router-link
                          v-if="!sub.child_components?.length"
                          :to="build_route_location(sub, component)"
                          @click="set_active_item(sub, 'sub')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_active(sub, 'sub') }"
                        >
                          {{ sub.name }}
                        </router-link>

                        <!-- If has child components -->
                        <a
                          v-else
                          class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center"
                          data-bs-toggle="collapse"
                          :href="'#collapse-' + sub.id"
                          role="button"
                          aria-expanded="false"
                          :aria-controls="'#collapse-' + sub.id"
                        >
                          <span>{{ sub.name }}</span>
                          <i class="bx bxs-chevrons-down rotate-icon"></i>
                        </a>

                        <!-- Nested child components -->
                        <ul
                          v-if="sub.child_components?.length"
                          class="ms-4 collapse list-unstyled ps-3"
                          :id="'collapse-' + sub.id"
                        >
                          <li
                            v-for="child in sub.child_components"
                            :key="child.id"
                            :class="{ 'd-none': is_hidden_sidebar_item(child) }"
                          >
                            <router-link
                              :to="build_route_location(child, sub)"
                              @click="set_active_item(child, 'child')"
                              class="nav-item nav-link text-decoration-none d-flex align-items-center"
                              :class="{ active: is_active(child, 'child') }"
                            >
                              <i v-if="child.icon_class" :class="child.icon_class" class="me-1 fs-4"></i>
                              {{ child.name }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                    </template>
                  </ul>
                </nav>
              </div>
              <!-- Main Sidebar -->
              <div v-else>
                <template v-if="sorted_menu_items?.length">
                  <a class="mt-3" id="sidebar-toggle" href="/company_management" @click.prevent="go_to_programmes">
                    <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
                  </a>
                  <hr class="text-white mx-2 mt-2"/>
                  <nav class="entity-sidebar">
                    <ul v-if="is_dwypd_recruitment_domain" class="nav flex-column">
                      <li>
                        <router-link
                          to="/overview"
                          @click="set_hardcoded_active('overview')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_route_active(['/overview']) }"
                        >
                          <i class="bi bi-house"></i>
                          <span class="sidebar-text">Overview</span>
                        </router-link>
                      </li>

                      <li class="dwypd-sidebar-group-label">Recruitment</li>
                      <li>
                        <router-link
                          to="/manage_entity_type"
                          @click="set_hardcoded_active('manage_entity_type')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: $route.path.includes('/manage_entity_type') }"
                        >
                          <i class="bi bi-clipboard"></i>
                          <span class="sidebar-text">Job Profiles</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{ path: '/view_entity_type', query: { all_adverts: 'true' } }"
                          @click="set_hardcoded_active('job_adverts')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: $route.path.includes('/view_entity_type') }"
                        >
                          <i class="bi bi-pencil-square"></i>
                          <span class="sidebar-text">Job Adverts</span>
                        </router-link>
                      </li>

                      <li class="d-none">
                        <router-link
                          to="/pending_applications"
                          @click="set_hardcoded_active('interviews')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_route_active(['/pending_applications']) }"
                        >
                          <i class="bi bi-calendar-event"></i>
                          <span class="sidebar-text">Interviews</span>
                        </router-link>
                      </li>

                      <li class="dwypd-sidebar-group-label d-none">Analytics</li>
                      <li class="d-none">
                        <router-link
                          to="/overview"
                          @click="set_hardcoded_active('reports')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_hardcoded_active('reports') }"
                        >
                          <i class="bi bi-bar-chart"></i>
                          <span class="sidebar-text">Reports</span>
                        </router-link>
                      </li>
                    </ul>

                    <ul v-else class="nav flex-column" v-for="component in sorted_menu_items" :key="component.id">
                      <li v-if="get_sidebar_group_label(component)" class="dwypd-sidebar-group-label">
                        {{ get_sidebar_group_label(component) }}
                      </li>
                      <li
                        v-for="sub in component.sub_components"
                        :key="sub.id"
                        :class="{ 'd-none': is_hidden_sidebar_item(sub) }"
                      >
                        <!-- Single router-link for items without children -->
                        <router-link
                          v-if="!sub.child_components?.length"
                          :to="build_route_location(sub, component)"
                          @click="set_active_item(sub, 'sub')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_active(sub, 'sub') }">
                          <i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-4"></i> <span class="sidebar-text" :title="get_sidebar_item_label(sub)">{{ get_sidebar_item_label(sub) }}</span>
                        </router-link>

                        <!-- Collapsible section for items with children -->
                        <template v-else>
                          <a
                            class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            :href="'#collapse-' + sub.id"
                            role="button"
                            aria-expanded="false"
                            :aria-controls="'#collapse-' + sub.id"
                          >
                            <span><i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-4"></i>
                              <span class="sidebar-text" :title="get_sidebar_item_label(sub)">{{ get_sidebar_item_label(sub) }}</span>
                            </span>
                            <i class="bx bxs-chevrons-down rotate-icon"></i>
                          </a>
                          <ul
                            class="ms-4 collapse list-unstyled"
                            :id="'collapse-' + sub.id">
                            <li
                              v-for="child in sub.child_components"
                              :key="child.id"
                              :class="{ 'd-none': is_hidden_sidebar_item(child) }"
                            >
                              <router-link
                                :to="build_route_location(child, sub, true)"
                                @click="set_active_item(child, 'child')"
                                class="nav-item nav-link text-decoration-none"
                                :class="{ active: is_active(child, 'child') }">
                                <i class='bx bxs-chevrons-right text-primary'></i>
                                <span class="sidebar-text" :title="get_sidebar_item_label(child)">{{ get_sidebar_item_label(child) }}</span>
                              </router-link>
                            </li>
                          </ul>
                        </template>
                      </li>
                    </ul>
                    <div class="sidebar-footer p-3 border-top border-dark mt-5">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-circle me-2 text-capitalize">
                            {{ (currently_logged_in || '').slice(0, 1) }}
                          </div>

                          <div class="user-info">
                            <p class="m-0 text-dark fw-bold text-xxs">{{ currently_logged_in }}</p>
                            <small class="text-dark text-xxs">{{ role }}</small>
                          </div>
                        </div>
                        <a href="/" class=" ms-2 nav-link nav-item p-0 text-muted text-xxs">
                          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
                        </a>
                      </div>
                  </nav>
                </template>
              </div>
            </div>
        </div>
    </div>
  </div>
</div>
